module.exports = __webpack_public_path__ + "img/translate2.f73f6436.jpg";